import { createContext, useContext } from "react";

// Types
import { CourseData } from "./types";

export type CoursesNewContextType = {
  course: CourseData | null;
  createCourse: (courseData: CourseData) => Promise<{ data: CourseData | null, success: boolean }>;
  updateCourse: (courseData: CourseData) => Promise<{ data: CourseData | null, success: boolean }>;
  processing: boolean;
}

const initialState: CoursesNewContextType = {
  course: null,
  createCourse: async (courseData: CourseData) => {
    return { data: courseData, success: true };
  },
  updateCourse: async (courseData: CourseData) => {
    return { data: courseData, success: true };
  },
  processing: false,
};

export const CoursesNewContext = createContext<CoursesNewContextType>(initialState);

export const useCoursesNewContext = () => {
  const context = useContext(CoursesNewContext);
  if (!context) {
    throw new Error("useCoursesNewContext must be used within a CoursesNewProvider");
  }
  return context;
};
